/**
 * Theme utility functions for managing the Academy marketing theme.
 *
 * The marketing theme extends the current HubSpot theme with Marketing brand colors.
 * Uses a separate localStorage key to avoid conflicting with HubSpot's theme system.
 */

const INBOUND_MARKETING_THEME_RELEASE_DATE_TIME = new Date('2025-09-03T15:00:00Z');

/**
 * Gets the Academy marketing theme preference from localStorage.
 * Uses a separate key to avoid conflicting with HubSpot's theme system.
 *
 * Will always return true if the current date is after the Inbound release date.
 */
export const getMarketingThemePreference = () => {
  if (new Date().getTime() > INBOUND_MARKETING_THEME_RELEASE_DATE_TIME.getTime()) {
    return true;
  }
  try {
    return localStorage.getItem('academy:marketing-theme') === 'true';
  } catch (error) {
    return false;
  }
};